import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import React from 'react'
import Ellipse from '../../images/integration-pages/ellipse'
import DocsCard from './DocsCard'
import DocsListItem from './DocsListItem'

const FeaturesDoc = ({
    docsTitle, docsDescription,
    featruesDocsSection1, featruesDocsTitle1 , featruesDocsDescription1,
    featruesDocsSection2, featruesDocsTitle2 , featruesDocsDescription2,
    featruesDocsSection3, featruesDocsTitle3 , featruesDocsDescription3,
    featruesDocsSection4, featruesDocsTitle4 , featruesDocsDescription4,
}) => {

    const data = useStaticQuery(graphql`
        query FeaturesDocQuery {
            IntegrationImage: file(
                absolutePath: {regex: "/images/integration-pages/features/"}
                name: {eq: "integrations"}
                ) {
                childImageSharp {
                    gatsbyImageData(placeholder: NONE)
                }
            }

            InstallationImage: file(
                absolutePath: {regex: "/images/integration-pages/features/"}
                name: {eq: "installation"}
                ) {
                childImageSharp {
                    gatsbyImageData(placeholder: NONE)
                }
            }

            MarketingImage: file(
                absolutePath: {regex: "/images/integration-pages/features/"}
                name: {eq: "marketing"}
                ) {
                childImageSharp {
                    gatsbyImageData(placeholder: NONE)
                }
            }

            AnalyticsImage: file(
                absolutePath: {regex: "/images/integration-pages/features/"}
                name: {eq: "analytics"}
                ) {
                childImageSharp {
                    gatsbyImageData(placeholder: NONE)
                }
            }

        }
    `)

    const integrationImage = getImage(data.IntegrationImage)
    const installationImage = getImage(data.InstallationImage)
    const marketingImage = getImage(data.MarketingImage)
    const analyticsImage = getImage(data.AnalyticsImage)

    return (
        <>
            <section className="w-11/12 mx-auto my-4 text-center lg:w-4/5 md:my-6">
                <div className="flex flex-col w-full mx-auto space-y-3 text-center lg:w-3/4">
                    <h2 className="text-2xl font-semibold leading-7 text-primary md:text-28px lg:text-32px xs:leading-8 md:leading-9 lg:leading-50px font-poppins" >{docsTitle}</h2>
                    <h5 className="w-11/12 mx-auto text-sm font-normal leading-7 lg:w-3/4 text-font_secondary md:text-base lg:text-lg font-roboto">{docsDescription}</h5>
                </div>
                
                {/* INTEGRATION */}
                <div className="relative w-full mt-10 md:mt-14 lg:mt-16 bg-features_docs_background rounded-t-2xl" style={{height: '570px'}}>

                    <DocsCard 
                        section={featruesDocsSection1}
                        title={featruesDocsTitle1}
                        description={featruesDocsDescription1}
                        feature1="100+ Popup tempaltes"
                        feature2="Easy to use customization options"
                        feature3="6+ unique popup forms"
                        feature4="Appealing gamification popups"
                    />
                    
                    <div className="absolute left-0 right-0 z-50 w-11/12 mx-auto 2xl:w-full -bottom-8 xs:-bottom-12 md:-bottom-28 lg:-bottom-72 xl:-bottom-80 2xl:-bottom-80">
                        <GatsbyImage 
                            image={integrationImage}
                            alt="Integeration and Customization"
                            // className={`w-11/12 h-auto xl:w-auto`}
                        />
                    </div>

                </div>

                {/* INSTALLATION */}
                <div className="relative w-full mt-14 xs:mt-20 md:mt-40 lg:mt-370px bg-features_docs_background rounded-t-2xl" style={{height: '570px'}}>

                    <DocsCard 
                        section={featruesDocsSection2}
                        title={featruesDocsTitle2}
                        description={featruesDocsDescription2}
                        feature1="Multiple popup types to choose from"
                        feature2="Lead generation, customer retention and more"
                        feature3="30+ ready to use popup templates"
                        feature4="Mobile responsive popups"
                    />
                    
                    <div className="absolute left-0 right-0 z-50 w-11/12 mx-auto 2xl:w-full -bottom-8 xs:-bottom-12 md:-bottom-28 lg:-bottom-72 xl:-bottom-80 2xl:-bottom-80">
                        <GatsbyImage 
                            image={installationImage}
                            alt="Installation and Signup"
                            // className={`w-11/12 h-auto xl:w-auto`}
                        />
                    </div>

                </div>

                {/* MARKETING */}
                <div className="relative w-full mt-14 xs:mt-20 md:mt-40 lg:mt-370px bg-features_docs_background rounded-t-2xl" style={{height: '570px'}}>

                    <DocsCard 
                        section={featruesDocsSection3}
                        title={featruesDocsTitle3}
                        description={featruesDocsDescription3}
                        feature1="Multiple EPS integerations"
                        feature2="Advanced triggering options"
                        feature3="Powerful targeting options"
                        feature4="Personlaized popups"
                    />
                    
                    <div className="absolute left-0 right-0 z-50 w-11/12 mx-auto 2xl:w-full -bottom-8 xs:-bottom-12 md:-bottom-28 lg:-bottom-72 xl:-bottom-80 2xl:-bottom-80">
                        <GatsbyImage 
                            image={marketingImage}
                            alt="Achieve Marketing Goals "
                            // className={`w-11/12 h-auto xl:w-auto`}
                        />
                    </div>

                </div>

                {/* ANALYTICS */}
                <div className="relative w-full mt-14 xs:mt-20 md:mt-40 lg:mt-370px bg-features_docs_background rounded-t-2xl" style={{height: '570px'}}>

                    <DocsCard 
                        section={featruesDocsSection4}
                        title={featruesDocsTitle4}
                        description={featruesDocsDescription4}
                        feature1="Create user grabbing popups"
                        feature2="Campaigns, subscribers, integration, settings, billing all in one place"
                        feature3="Eliminate guess work"
                        feature4="In-depth stats that matter"
                    />
                    
                    <div className="absolute left-0 right-0 z-50 w-11/12 mx-auto 2xl:w-full -bottom-8 xs:-bottom-12 md:-bottom-28 lg:-bottom-72 xl:-bottom-80 2xl:-bottom-80">
                        <GatsbyImage 
                            image={analyticsImage}
                            alt="Detailed Dashboard Analytics"
                            // className={`w-11/12 h-auto xl:w-auto`}
                        />
                    </div>

                </div>
            </section>
        </>
    )
}

export default FeaturesDoc
